<template>
    <!-- Notifications -->
    <v-snackbar
      v-model="notificationModel"
      :color="notificationColor"
      :timeout="3000"
      location="top"
    >
      {{ notificationText }}
    </v-snackbar>
  
    <!-- Loading Overlay -->
    <div v-if="isLoading" 
      class="fixed inset-0 bg-white/80 backdrop-blur-sm z-50 flex flex-col items-center justify-center">
      <img src="/ducksImages/duckLoader.webp" alt="Loading" class="h-32 w-32 animate-bounce mb-4" />
      <p class="text-lg font-medium text-slate-800 animate-pulse">Loading duck information...</p>
    </div>
  </template>
  
  <script setup lang="ts">
  import { computed } from 'vue';
  
  const props = defineProps({
    notification: {
      type: Boolean,
      required: true
    },
    notificationText: {
      type: String,
      default: ''
    },
    notificationColor: {
      type: String,
      default: 'success'
    },
    isLoading: {
      type: Boolean,
      default: false
    }
  });
  
  const emit = defineEmits(['update:notification']);
  
  // Create a computed property for two-way binding
  const notificationModel = computed({
    get: () => props.notification,
    set: (value) => emit('update:notification', value)
  });
  </script>